<template>
  <div class="WCaborder">
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item :to="{ path: '/wContainer' }">>柜子列表</el-breadcrumb-item>
      <el-breadcrumb-item>柜子详情</el-breadcrumb-item>
    </el-breadcrumb>
    <el-tabs type="border-card" v-model="activeTab" @tab-click="hand" style="margin-top: 20px;">
        
        <el-tab-pane label="尾端柜子详情" name="1">
        <!-- <Cabdetails :plannames="planName"></Cabdetails> -->
        <WCabdetails :plannames="planName"></WCabdetails>
      </el-tab-pane>
      <el-tab-pane label="物流进度" name="2">
        <div class="main" >
        <!-- 物流进度 -->
            <el-card  style="width:48%">
            <div slot="header" class="clearfix">
                <b>物流进度</b>
            </div>
            <el-timeline>
                <el-timeline-item
                v-for="(item, index) in schedule"
                :key="index"
                :icon="item.icon"
                :size="item.size"
                :type="item.type"
                :color="item.color"
                >
                <b>{{item.content}}</b>
                <span style="margin-left:15px">{{item.createTime2|formatDate}}</span>
                </el-timeline-item>
            </el-timeline>
            </el-card>
        </div>
      </el-tab-pane>     
      
    </el-tabs>
  </div>  
</template>
<script>
import httpApi from "@/http/api";
import WCabdetails from "@/views/orderevent/WCabdetails";
import { formatTimeToStr } from "@/util/toLocaleString.js";
export default {
  name: "Caborder",
  components: {
    WCabdetails, //柜子详情
  },
  data() {
    return {
      containerId:"",
      planName:"",
      activeTab:"1",
      schedule: [], 
      findLogData:[]
    };
  },
  methods: {
      //查订单详情
    init() {
      let that = this;
      that.orderNo = this.planName;
      httpApi
        .containerLogistics({
          params: { planName: that.planName }
        })
        .then(res => {
          if (res.data.code == "ok") {
            //物流进度
            that.schedule = res.data.data;
            //操作记录
            that.findLogData = res.data.data;
          } else {
            that.$message.error(res.data.message);
          }
        });
    },
     hand(tab) {
      localStorage.removeItem("cabTab");
      localStorage.setItem("cabTab", tab.name);
    },
    uptype() {
      if (localStorage.getItem("cabTab")) {
        this.activeTab = localStorage.getItem("cabTab");
      }
    },
  },
  created() {
    // this.containerId = this.$route.query.containerId.toString();
    // this.planName=this.$route.query.planName;
      this.planName=this.$route.params.planName
    this.uptype();
    this.init();
  },
  filters: {
    formatDate: function(time) {
      if (time != null && time != "") {
        var date = new Date(time * 1000);
        // eslint-disable-next-line no-undef
        return formatTimeToStr(date, "yyyy-MM-dd hh:mm:ss");
      } else {
        return "";
      }
    }
  },

};
</script>
<style lang="less" scoped>
/deep/.main {
  width: 100%;
  height: auto;
  display: flex;
  margin-top: 10px;
  justify-content: space-between;
    /deep/.el-timeline {
      margin-top: 10px;
      .el-timeline-item__wrapper {
        text-align: left;
      }
      li:first-child .el-timeline-item__wrapper .el-timeline-item__content {
        color: red !important;
      }
      .el-timeline-item__tail {
        left: 7px;
      }
      .el-timeline-item__node--large {
        left: 1px;
      }
      .el-timeline-item__node--normal {
        left: 2px;
      }
    }
}
</style>